module.exports = __webpack_public_path__ + "static/img1-8e8d91162675868cb27705616a17cfe2.svg";